import axios from "axios"
import url from "../utils/url";

export const enviarMail = async (mailData) => {
    return await axios.post(`${url}/api/enviarMail?from=interno`, mailData)
}

